import React, { Component } from 'react';
import { connect } from 'react-redux';

import history from '../../history';

export default function (ComposedComponent){

  class Authentication extends Component {

    UNSAFE_componentWillMount(){
      if(!this.props.authenticated) history.push('/')
    }

    UNSAFE_componentWillReceiveProps(NextProps){
      if(!NextProps.authenticated) history.push('/')
    }

    render(){
      return <ComposedComponent {...this.props}/>
    }

  }

  function mapStateToProps(state) {
    return { authenticated: state.auth.authenticated };
  }

  return connect(mapStateToProps)(Authentication);

  // return connect(mapStateToProps)(Authentication);


}
